<template>
  <div class="w-full text-xl bg-neutral-50 border border-neutral-200 rounded-xl pl-4 pr-5 py-5">
    <vetster-accordion
      :default-open="!$screen('mobile')"
      :always-open="!$screen('mobile')"
      :hide-toggle-icon="!$screen('mobile')"
      is-refresh
      content-padding="pr-0"
      title-class="text-base"
      panel-class="!px-0 !py-0"
    >
      <template #title>
        <div class="flex items-center space-x-2 lg:space-x-2.5">
          <lottie-player
            autoplay
            loop
            mode="normal"
            :src="lottieUrl"
            class="size-6"
          />
          <span class="text-neutral-900 font-title !font-medium text-xl lg:text-2xl">
            {{ $t('search.your-recommended-vet') }}
          </span>
        </div>
      </template>
      <template #content>
        <ul class="space-y-[6px] text-neutral-700 mt-4 text-sm lg:text-base">
          <li class="flex space-x-3 items-center">
            <fa :icon="['fal', 'check']" />
            <span>{{ $t('search.licensed-in-your-state') }}</span>
          </li>
          <li
            v-if="isTopRated"
            class="flex space-x-3 items-center"
          >
            <fa :icon="['fal', 'check']" />
            <span>{{ $t('search.reviewed-by-pet-parents', { reviewCount: formatReviewCount(reviewCount) }) }}</span>
          </li>
          <li
            v-if="isTopRated"
            class="flex space-x-3 items-center"
          >
            <fa :icon="['fal', 'check']" />
            <span>{{ topRatedText }}</span>
          </li>
          <li
            v-if="isPrescriptionAvailable"
            class="flex space-x-3 items-center"
          >
            <fa :icon="['fal', 'check']" />
            <span>{{ $t('search.prescriptions-available') }}</span>
          </li>
        </ul>
      </template>
    </vetster-accordion>
  </div>
</template>

<script>
import VetsterAccordion from '@/components/VetsterAccordion';
import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterRecommendVetStats',

  components: { VetsterAccordion },

  props: {
    isPrescriptionAvailable: {
      type: Boolean,
      default: false,
    },
    reviewCount: {
      type: Number,
      default: 0,
    },
    topRatedText: {
      type: String,
      default: '',
    },
  },

  computed: {
    isTopRated() {
      return this.reviewCount >= 10;
    },
    lottieUrl() {
      return getAssetUrl('lottie/sparkle-bubblegum.json');
    },
  },

  methods: {
    formatReviewCount(count) {
      if (count === 10) {
        return '10';
      }

      if (count < 100) {
        return `${Math.floor(count / 10) * 10}+`;
      }

      if (count < 1000) {
        return `${Math.floor(count / 100) * 100}+`;
      }

      const thousands = (count / 1000).toFixed(1);

      return thousands.endsWith('.0') ? `${parseInt(thousands, 10)}k+` : `${thousands}k+`;
    },
  },
};
</script>
